// extracted by mini-css-extract-plugin
export default {"bottle-board":"BottleSpinBoard_bottle-board__SRzY0","bottle-empty":"BottleSpinBoard_bottle-empty__UPMnt"};